var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64086 9.95803L11.4414 3.23809C11.7992 2.88243 12 2.4013 12 1.8998C12 1.3983 11.7992 0.917178 11.4414 0.56151C11.2628 0.383587 11.0503 0.242364 10.8162 0.145991C10.5821 0.0496174 10.331 0 10.0774 0C9.82383 0 9.57274 0.0496174 9.33864 0.145991C9.10454 0.242364 8.89207 0.383587 8.71349 0.56151L0.568243 8.61025C0.388186 8.78672 0.245271 8.99667 0.147742 9.22799C0.0502133 9.45932 0 9.70743 0 9.95803C0 10.2086 0.0502133 10.4567 0.147742 10.6881C0.245271 10.9194 0.388186 11.1293 0.568243 11.3058L8.71349 19.4495C8.89299 19.6254 9.10587 19.7646 9.33993 19.8591C9.57398 19.9535 9.82461 20.0014 10.0774 20C10.3303 20.0014 10.5809 19.9535 10.8149 19.8591C11.049 19.7646 11.2619 19.6254 11.4414 19.4495C11.7992 19.0938 12 18.6127 12 18.1112C12 17.6097 11.7992 17.1285 11.4414 16.7729L4.64086 9.95803Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.0b9e8f0275d3621130beaef85c60a48a.svg";
export { ForwardRef as ReactComponent };